import React from "react";
import MpTextFieldMultiple from "../../../../components/MpTextFieldMultiple";

interface IProps {
  value: string;
  onChange: (event: any) => void;
  label: string;
  count?: number;
}

const WalletDisplayNameMultipleTextField = (props: IProps) => {
  const { value, onChange, label, count } = props;

  return (
    <>
      <MpTextFieldMultiple
        value={value}
        onChange={onChange}
        label={label}
        count={count || value ? value.split(",").length : 0}
      />
    </>
  );
};

export default WalletDisplayNameMultipleTextField;
